// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"e8fd330c","455":"dad5324d","977":"d159d99e"}[chunkId] + ".chunk.js";
};